import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqList } from "@/mocks/catalog";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqList[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="关于这个页面，你可能想先知道的几件事"
          desc="把浏览时常被问到的疑问集中在这里，点击问题即可展开查看回答。"
        />

        <div className="mt-10 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
          {faqList.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className="h-fit overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/50"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={`text-base ${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
                    </span>
                  </button>
                </h3>
                {open ? (
                  <div className="border-t border-background-200/70 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}